
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Communiquer efficacement : quels supports choisir ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les supports de communication les plus efficaces pour interagir avec vos clients, collaborateurs et partenaires, et renforcer votre impact.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Communiquer efficacement : sur quels supports ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Niveaux, types, supports ou astuces, cet article vous explique les clés d’une communication efficace avec vos clients, collaborateurs et partenaires.",
        },
      ],
    };
  },
};
